import * as paginationService from '@/legacy/services/pagination';
import { SessionTimeoutService } from '@/legacy/services/sessionTimeout';
import * as plootoUtils from '@/legacy/utils/plooto';

export class PromiseWithXhr<T> {
  public dataPromise: JQueryPromise<T>;

  public xhr: JQueryXHR;

  public getXhr: () => JQueryXHR;

  public contentRange: paginationService.ContentRangeHeader;

  // Allows us to process data before we return it back
  public dataProcessCallback: (data: any) => T;

  constructor() {
    this.dataPromise = $.Deferred();
  }

  public abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }
}

/** @deprecated Use `ApiService` instead. */
export class XhrService {
  /**
   * This will re-try the xhr if there is a login error
   * @deprecated Use `ApiService` instead.
   */
  public initiatePromiseWithXhr<T>(promiseWithXhr: PromiseWithXhr<T>): JQueryPromise<any> {
    let retryCounter = 0;

    const executeXhr = () => {
      promiseWithXhr.xhr = promiseWithXhr.getXhr();
      return promiseWithXhr.xhr.then((data, textStatus, jqXHR: JQueryXHR) => {
        if (data && data.error && data.type == 'invalid.authentication') {
          return SessionTimeoutService.showTimeout().then((loginResponse) => {
            if (loginResponse) {
              // Prevent infinite loop (if somehow we get invalid.authentication 3 times in a row after after successful login)
              retryCounter += 1;
              if (retryCounter > 3) {
                return (promiseWithXhr.dataPromise as any).reject(data);
              }

              return executeXhr(); // re-try this method
            }
            return undefined;
          });
        }

        if (plootoUtils.IsNullOrUndefined(data) || data.error === true) {
          return (promiseWithXhr.dataPromise as any).reject(data);
        }

        // add content range header to our object if one exists
        const contentRangeHeader = jqXHR.getResponseHeader('content-range');
        if (contentRangeHeader) {
          promiseWithXhr.contentRange = paginationService.ContentRangeHeader.fromString(
            jqXHR.getResponseHeader('content-range')
          );
        }

        if (promiseWithXhr.dataProcessCallback) {
          const dataCallbackResults = promiseWithXhr.dataProcessCallback(data);
          (promiseWithXhr.dataPromise as any).resolve(dataCallbackResults);
        } else {
          (promiseWithXhr.dataPromise as any).resolve(data);
        }

        retryCounter = 0; // Reset retry count
        return undefined;
      });
    };
    return executeXhr();
  }
}
export const Instance = new XhrService();
